import { useState } from "react";
import moment from "moment";
import { subscriptionService, taskService } from "@miplatform/api";
import {
  TECHNICIAN_ACTIVITY_STATUSES_KEYED,
  TECHNICIAN_AVAILABAILITY_STATUSES_KEYED,
  TECHNICIAN_STATUSES_TYPES,
} from "@miplatform/constants";
import { uncapitalize } from "@miplatform/utils";
import * as mdi from "@mdi/js";
import { useGlobalManagerApproval } from "../../../../components/GlobalManagerApprovalProvider/GlobalManagerApprovalProvider";

export const useUserDetailsViewModel = ({ user = {}, date }) => {
  const [isClearScheduleModalOpen, setIsClearScheduleModalOpen] =
    useState(false);
  const { executeApiRequest } = useGlobalManagerApproval();

  const openClearScheduleModal = () => {
    setIsClearScheduleModalOpen(true);
  };

  const closeClearScheduleModal = () => {
    setIsClearScheduleModalOpen(false);
  };

  const clearSchedule = async (reason) => {
    const data = {
      userId: user.id,
      date: moment(date).toISOString(),
      reason,
    };
    const options = await taskService.attempts.clearScheduleOptions({ data });
    await executeApiRequest({
      options,
      successToastMessageForManagerApproval: {
        text: `${user.name}'s schedule was cleared.`,
      },
      callback: () => {
        closeClearScheduleModal();
      },
    });
  };

  const updateStatus = async ({ value, type }) => {
    if (user[uncapitalize(type)] === value) {
      return;
    }

    await subscriptionService.users.updateActivityStatus({
      id: user.id,
      data: {
        [type]: value,
        modifiedOn: user.modifiedOn,
      },
      toastMessageConfig: {
        success: {
          text: `${user.name}'s status was edited.`,
        },
      },
    });
  };

  const getStatuses = (type) =>
    Object.values(
      type === TECHNICIAN_STATUSES_TYPES.AVAILABILITY
        ? TECHNICIAN_AVAILABAILITY_STATUSES_KEYED
        : TECHNICIAN_ACTIVITY_STATUSES_KEYED
    ).map((statusObject) => ({
      ...statusObject,
      icon: mdi[statusObject.icon],
      type,
      action: updateStatus,
    }));

  return {
    activityStatuses: getStatuses(TECHNICIAN_STATUSES_TYPES.ACTIVITY),
    clearSchedule,
    isClearScheduleModalOpen,
    openClearScheduleModal,
    closeClearScheduleModal,
  };
};
